import React from 'react'

export default {
  traitFilters: (
    <div className={'insights-portal-point-tip'}>
      Apply filters to your portal using aytm Traits to view specific cuts of your data. Any combination of variables
      can be used together to filter your data.
    </div>
  ),
  virtualFilters: (
    <div className={'insights-portal-point-tip'}>
      Apply filters to your portal using variables at the respondent level to view specific cuts of your data. Any
      combination of variables can be used together to filter your data.
    </div>
  ),
  variableFilters: (
    <div className={'insights-portal-point-tip'}>
      Apply filters to your portal using variables at the dataset level to view specific cuts of your data. Any
      combination of variables can be used together to filter your data.
    </div>
  ),
  externalDataFilters: (
    <div className={'insights-portal-point-tip'}>
      Show or hide external data added to your portal. External data is shown by default. To hide external data from
      view, deselect external you would like to hide and click apply filters. Note: since subgroup data points are not
      input for external data, external data cannot be filtered by traits or variables.
    </div>
  ),
  portalConcept: (
    <div className={'insights-portal-point-tip'}>
      Concept Portal is a powerful analysis solution that allows you to analyze multiple concept test surveys in one
      convenient place. In a Concept Portal, you can do the following:
      <ul>
        <li>Compare the performance of concepts and metrics across surveys.</li>
        <li>Interact with data from multiple different surveys in one place.</li>
        <li>Visualize top performers across surveys for frictionless analysis.</li>
        <li>Add data manually to establish benchmarks with external data sources.</li>
      </ul>
    </div>
  ),
  portalTracker: (
    <div className={'insights-portal-point-tip'}>
      Tracker Portal is a powerful analysis solution that allows you to analyze multiple waves of your tracker study in
      one convenient place. In a Tracker Portal, you can do the following:
      <ul>
        <li>Track the performance of multiple entities, brands, or products over time.</li>
        <li>Interact with data from multiple different surveys in one place.</li>
        <li>Add data manually to establish benchmarks with external data sources.</li>
        <li>Perform significance testing across waves for total level and subgroup analysis.</li>
      </ul>
    </div>
  ),
  regenSigTestLetters: (
    <div className={'insights-portal-point-tip'}>
      Reassign significance test letters in this portal to ensure that concepts are assigned consecutive letters
      starting with “A”.
    </div>
  ),
  regenSigTestLettersWaves: (
    <div className={'insights-portal-point-tip'}>
      Reassign significance test letters in this portal to ensure that waves are assigned consecutive letters starting
      with “A”.
    </div>
  ),
  warnExternalData: (
    <div className={'insights-portal-point-tip'}>
      <b>Note:</b> external data cannot be filtered.
    </div>
  ),
  warnDataSources: (
    <div className={'insights-portal-point-tip'}>
      <b>Note:</b> modifying the data sources will result in corresponding changes across all saved views.
    </div>
  )
}
